import { useMutation } from "@tanstack/react-query";
import { GuestTruckingContSealRequestDto } from "../dtos/GuestTruckingContSealRequestDto";
import { shipmentTruckingGuestService } from "../services/shipmentTruckingGuestService";

export const useUpdateContSeal = () => {
  return useMutation({
    mutationFn: ({ shipmentTruckingId, payload }: { shipmentTruckingId: string; payload: GuestTruckingContSealRequestDto }) =>
      shipmentTruckingGuestService.updateContSeal(shipmentTruckingId, payload),
  });
};
